import { render, staticRenderFns } from "./protocolModal.vue?vue&type=template&id=13bbd9e6&scoped=true&"
import script from "./protocolModal.vue?vue&type=script&lang=js&"
export * from "./protocolModal.vue?vue&type=script&lang=js&"
import style0 from "./protocolModal.vue?vue&type=style&index=0&id=13bbd9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbd9e6",
  null
  
)

export default component.exports